import axios from "axios";
const URL = process.env.REACT_APP_API_BASE_URL;

export const getAuthToken = async () => {
  try {
    const response = await axios.get(`${URL}/paytrace/getAuthToken`);
    return response?.data?.paytraceAuthToken;
  } catch (error) {
    console.log("error", error);
  }
};

export const getClientKey = async () => {
  try {
    const response = await axios.get(`${URL}/paytrace/getClientKey`);
    return response?.data?.clientKey;
  } catch (error) {
    console.log("error", error);
  }
};

export const initiatePayment = async (
  amount,
  hpf_token,
  enc_key,
  customerInfo, // Customer information from React form
  description,
  rptID,
  selectedInspections, // Selected inspection types and amounts
  recaptchaToken // reCAPTCHA token for bot protection
) => {
  try {
    const payload = {
      amount: amount.toString(),
      hpfToken: hpf_token,
      encKey: enc_key,
      description: description,
      billingAddress: {
        streetAddress: customerInfo?.address,
        streetAddress2: "", // Assuming no second address line
        city: customerInfo?.city,
        state: customerInfo?.state,
        zip: customerInfo?.zipcode?.toString() ?? "",
        country: "" // Assuming no country information
      },
      rptID: rptID,
      customerName: customerInfo.name,  // Name on card (Required)
      customerEmail: customerInfo.email,        // Email address (Required)
      customerPhone: customerInfo.phone,        // Phone number (Optional)
      selectedInspections: selectedInspections, // Selected inspection types
      recaptchaToken: recaptchaToken            // reCAPTCHA token for bot protection
    };

    const response = await axios.post(`${URL}/paytrace/processPayment`, payload);
    return response;
  } catch (error) {
    console.log("error", error);

    // Pre-gateway rejections (minimum amount, validation, card-testing guard)
    // come back as HTTP 400 with { success:false, error, code }. Returning the
    // raw axios error hid that payload, so the receipt rendered blank. Hand back
    // the same {status, data} shape as a success so callers read it uniformly.
    if (error?.response) {
      return error.response;
    }

    return {
      status: 0,
      data: {
        success: false,
        error: "We could not reach the payment server. Please check your connection and try again.",
      },
    };
  }
};

// Fire-and-forget telemetry so payment-form load failures show up in backend
// logs. They previously died silently in the user's browser console, which is
// why the "endless spinner" complaints could never be traced.
export const logClientEvent = async (stage, message, rptID) => {
  try {
    await axios.post(`${URL}/paytrace/clientLog`, {
      stage,
      message: String(message || "").slice(0, 500),
      rptID: rptID ?? null,
      userAgent: navigator.userAgent,
    });
  } catch {
    // telemetry must never affect the payment flow
  }
};

export const getBillingSummary = async (address, zip) => {
  try {
    const response = await axios.get(`${URL}/Invoices/billing-summary`, {
      params: { address, zip },
    });
    return response?.data;
  } catch (error) {
    console.log("error", error);
    return [];
  }
};

export const getInspectionPrices = async (address, zip, rptId) => {
  try {
    const response = await axios.get(`${URL}/Invoices/inspection-prices`, {
      params: { address, zipCode: zip, rptId },
    });
    return response?.data;
  } catch (error) {
    console.log("error", error);
    return [];
  }
};
